import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import CheckIcon from "@mui/icons-material/Check";
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import IconsColor from "../../utility/iconsColor";

// Sample shown in the Request Parameters info tooltip (placing a food order)
export const SAMPLE_REQUEST_PARAMETERS_JSON = {
    type: "object",
    properties: {
        customer_name: { type: "string", description: "Name of the customer" },
        quantity: { type: "number", description: "Number of items to order" },
        delivery_address: {
            type: "object",
            description: "Where the order should be delivered",
            properties: {
                city: { type: "string", description: "City name" }
            },
            required: ["city"]
        },
        items: {
            type: "array",
            description: "Names of the food items",
            items: { type: "string", description: "Food item name" }
        }
    },
    required: ["customer_name", "quantity", "delivery_address", "items"]
}; 

export const getRequestParametersFormatTooltip = () => (
    <div className={styles.requestParamsTooltip}>
        <div className={styles.requestParamsTooltipTitle}>Request Parameters format</div>
        <div>Use this JSON Schema:</div>
        <ul className={styles.requestParamsTooltipList}>
            <li>
                Types: <code>string</code>, <code>number</code>, <code>object</code>, <code>array</code>. No <code>boolean</code>; use <code>string</code> for true/false.
            </li>
            <li>
                Every field needs a <code>description</code>. The AI uses it to know what to ask for.
            </li>
            <li>
                <code>required</code> must list <strong>every</strong> field. For optional ones, write "send empty string if not provided" in the description.
            </li>
        </ul>
        <SampleRequestParametersCode />
    </div>
);

// Sample JSON block with a copy icon in the top right corner, shown on hover
const SampleRequestParametersCode = () => {
    const [flagCopied, setFlagCopied] = useState(false);
    const sampleJson = JSON.stringify(SAMPLE_REQUEST_PARAMETERS_JSON, null, 2);

    return (
        <div className={styles.requestParamsTooltipCodeWrapper}>
            <pre className={styles.requestParamsTooltipCode}>
                {sampleJson}
            </pre>
            <CopyToClipboard
                text={sampleJson}
                onCopy={() => {
                    setFlagCopied(true);
                }}
            >
                <span
                    className={styles.requestParamsTooltipCopyIcon}
                    onMouseLeave={() => setFlagCopied(false)}
                >
                    {/* Tick after copying, back to the copy icon once the cursor leaves the icon */}
                    {flagCopied ?
                        <CheckIcon className={styles.requestParamsTooltipCopiedIcon} />
                        :
                        <IconsColor iconName="Copy" height="14" width="14" fillColor="#000" />
                    }
                </span>
            </CopyToClipboard>
        </div>
    );
};

// The API returns the JSON as a single-line string; indent it so the editors show it as a readable object
export const formatJsonForEditor = (jsonData) => {
    if (jsonData === null || jsonData === undefined || jsonData === "") return "";
    if (typeof jsonData !== "string") return JSON.stringify(jsonData, null, 4);
    try {
        return JSON.stringify(JSON.parse(jsonData), null, 4);
    } catch {
        return jsonData;
    }
};

export const formatDataConnectorJson = (dataConnectors) => dataConnectors.map((dataConnector) => {
    const functions = dataConnector?.data_connector_functions;
    if (!functions) return dataConnector;
    return {
        ...dataConnector,
        data_connector_functions: {
            ...functions,
            data_connector_function_parameters: functions?.data_connector_function_parameters && {
                ...functions.data_connector_function_parameters,
                function_parameter_json_data: formatJsonForEditor(functions?.data_connector_function_parameters?.function_parameter_json_data),
            },
            data_connector_function_response: functions?.data_connector_function_response && {
                ...functions.data_connector_function_response,
                function_response_json_data: formatJsonForEditor(functions?.data_connector_function_response?.function_response_json_data),
            },
        },
    };
});